<template>
  <div class="timeline">
    <div v-if="isMy" class="updates-bt-block">
      <div>
        <div class="text_large">{{ i18n.sale_updates_empty_header() }}</div>
        <div class="text_small text_description text_margin">{{ i18n.sale_updates_empty_text() }}</div>
      </div>
      <div>
        <md-button class="btn md-primary"
                @click="handleAddClick"

        >
          {{ i18n.sale_updates_add_note_bt() }}
        </md-button>
      </div>
    </div>
    <timeline-item
      class="timeline__timeline-item"
      v-for="(item, i) in items"
      :key="i"
      :title="item.title"
      :date="i18n.d(item.date)"
      :message="linkify(item.message)"
    />
  </div>

</template>

<script>
  import TimelineItem from './UpdatesTab.Timeline.Item'
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  export default {
    name: 'timeline',

    components: {
      TimelineItem
    },
    props: ['sale', 'items'],
    data: _ => ({
      i18n
    }),
    computed: {
      ...mapGetters([
        vuexTypes.accountId
      ]),
      isMy () {
        return this.sale.owner === this.accountId
      }
    },
    methods: {
      handleAddClick () {
        this.$emit(commonEvents.timelineAddClick)
      },
      linkify (text) {
        /*eslint-disable*/
        const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
        /*eslint-enable*/
        return text.replace(urlRegex, (url) => '<a href="' + url + '" target="_blank">' + url + '</a>')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.vue